import { STARTDATES } from './types';

export default {
  startDates: state => state[STARTDATES],
};
